import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

/**
 * The left rail on a long event page: what is on it, where you are, how long it takes to read.
 * Items are only shown when their section exists; the active one carries the sol mark. Desktop only.
 */
export const EventRail = ({ items, words = 0, className }) => {
  const [active, setActive] = useState(items[0]?.id);
  useEffect(() => {
    const els = items.map((it) => document.getElementById(it.id)).filter(Boolean);
    if (!els.length) return undefined;
    const io = new IntersectionObserver((entries) => {
      const hit = entries.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
      if (hit) setActive(hit.target.id);
    }, { rootMargin: "-20% 0px -65% 0px", threshold: [0, 1] });
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [items]);
  if (!items.length) return null;
  const minutes = Math.max(1, Math.round(words / 200));
  return (
    <nav className={cn("hidden lg:block", className)} aria-label="Innhald på sida" data-testid="event-rail">
      <ol className="space-y-2.5">
        {items.map((it) => (
          <li key={it.id}>
            <a href={`#${it.id}`} onClick={(e) => { e.preventDefault(); document.getElementById(it.id)?.scrollIntoView({ behavior: "smooth", block: "start" }); }}
              className={cn("group flex items-center gap-3 text-[13px] leading-snug transition-colors", active === it.id ? "text-foreground" : "text-muted-foreground hover:text-foreground")} aria-current={active === it.id ? "true" : undefined} data-testid={`event-rail-${it.id}`}>
              <span className={cn("h-px shrink-0 transition-all duration-300", active === it.id ? "w-6 bg-sol" : "w-3 bg-border group-hover:w-5 group-hover:bg-foreground/40")} aria-hidden="true" />
              <span className="truncate">{it.label}</span>
            </a>
          </li>
        ))}
      </ol>
      {words > 150 && <p className="t-mono mt-6 text-muted-foreground" data-testid="event-reading-time">{minutes} min lesing</p>}
    </nav>
  );
};
